import JsxHelper from '../Helpers/JsxHelper';
import paidOutsideOfSystemHelper from '../Helpers/paidOutsideOfSystemHelper';
import React from 'react';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import Comments from '../Elements/Comments';
import LogComponent from '../Elements/LogComponent';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import AttachmentsComponent from '../Elements/AttachmentsComponent';
import AssignmentStatusNameComponent from '../Elements/AssignmentStatusNameComponent';
import SurveyNameComponent from '../Elements/SurveyNameComponent';
import ClientUnitService from '../Services/ClientUnitService';
import ShowNameComponent from '../Elements/ShowNameComponent';
import EvaluatorService from '../Services/EvaluatorService';
import AssignmentService from '../Services/AssignmentService';
import LookupText from '../Elements/LookupText';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import ProjectService from '../Services/projectService';
import AuthService from '../Services/authService';
import urlHelper from '../Helpers/urlHelper';

export default class AssignmentItem {
  constructor(item) {
    if (item === undefined) {
      this.AsId = '';
      this.AsCuid = '';
      this.AsSassieReferenceNumber = '';
      this.AsLgsid = '';
      this.AsLdvid = '';
      this.AsLdvname = '';
      this.AsSassieShopComments = '';
      this.AsCfid = '';
      this.AsGroup = '';
      this.AsEvalFee = '';
      this.AsVat = '';
      this.AsBillToUnit = '';
      this.AsEvid = '';
      this.AsExclude = '';
      this.AsInid = '';
      this.AsUsid = '';
      this.AsUsname = '';
      this.AsMod = '';
      this.AsCreateId = '';
      this.AsCreateDt = '';
      this.AsSassieUnitId = '';
      this.AsSassieEvalId = '';
      this.AsSassieAsgnId = '';
      this.AsSassieSurveyId = '';
      this.AsEvaluatorCompletedDate = '';
      this.AsIob = '';
      this.AsUninvoiceable = '';
      this.PaidOutsideOfSystem = '';
      this.CanTogglePaidOutsideOfSystem = false;
      this.AsPayEvaluator = '';
      this.AsBillClient = '';
      this.AsAdHocGroup = '';
      this.AsDeletedInApollo = '';
      this.IsApproved = '';
      this.AsFieldworkFee = '';
      this.AsIeFee = '';
      this.AsIeFeeAdjustment = '';
      this.AsIeReimbursement = '';
      this.AsIeTravel = '';
      this.AsIeGaming = '';
      this.AsIeMisc = '';
      this.AsIeFeeAdjustmentReason = '';
      this.AsIeReimbursementAdjustmentReason = '';
      this.AsIeEvaluatorCompletedDate = '';
      this.AsIeReceivedDate = '';
      this.AsIePaymentDate = '';
      this.LgsDesc = '';
      this.LgsComplete = '';
      this.CuId = '';
      this.CuName = '';
      this.CuCity = '';
      this.CuState = '';
      this.CuCountry = '';
      this.CuUserLocId = '';
      this.CcId = '';
      this.CcCompanyName = '';
      this.AsEvname = '';
      this.InId = '';
      this.InCiid = '';
      this.CiStatusCode = '';
      this.CiYrmo = '';
      this.InRcyid = '';
      this.InRcysymbol = '';
      this.InRcycode = '';
      this.InFee = '';
      this.InFieldworkFee = '';
      this.InFeeAddit = '';
      this.InReimbursement = '';
      this.InMisc = '';
      this.InTravel = '';
      this.InGaming = '';
      this.InCreditAmount = '';
      this.InLateFee = '';
      this.InInitialTotalDue = '';
      this.InVat = '';
      this.InCurrentTotalDue = '';
      this.AsCfname = '';
      this.AsCfDisplayName = '';
      this.AsPricingId = '';
      this.AsPricingName = '';
      this.IeId = '';
      this.IeFee = '';
      this.IeFeeAdjustment = '';
      this.IeReimbursement = '';
      this.IeMisc = '';
      this.IeTravel = '';
      this.IeGaming = '';
      this.IeVat = '';
      this.IeVatfee = '';
      this.IeVatreimb = '';
      this.IeDue = '';
      this.IeTotal = '';
      this.IeTotalFee = '';
      this.IeTotalReimb = '';
      this.IeStatusCode = '';
      this.IePaymentDate = '';
      this.IeRcyid = '';
      this.IeRcyname = '';
      this.IeRcysymbol = '';
      this.AsRcyid = '';
      this.AsRcycode = '';
      this.AsRcysymbol = '';
      this.AsRcyidOwningOffice = '';
      this.AsRcycodeOwningOffice = '';
      this.AsRcysymbolOwningOffice = '';
      this.AsOwningOfficeId = '';
      this.AsOwningOfficeName = '';
      this.AsPricingRoundFee = '';
      this.AsFee = '';
      this.AsFeeOwningOffice = '';
      this.AsFeeAddit = '';
      this.AsFeeReason = '';
      this.AsReimbursement = '';
      this.AsMisc = '';
      this.AsTravel = '';
      this.AsGaming = '';
      this.CountryId = '';
      this.CountryName = '';
      this.EvaluatorOfficeId = '';
      this.EvaluatorOfficeName = '';
      this.EvaluatorCurrencyId = '';
      this.EvaluatorCurrencyName = '';
      this.ReimbursementCurrencyId = '';
      this.ReimbursementCurrencyName = '';
      this.ClientReimbursementCurrencyId = '';
      this.ClientReimbursementCurrencyName = '';
      this.ClientBillingCurrencyName = '';
      this.ClientBillingCurrencyId = '';
      this.AsWaveId = '';
      this.AsWaveName = '';
      this.CuLevel1Name = '';
      this.CuLevel2Name = '';
      this.CuLevel3Name = '';
      this.CuLevel4Name = '';
      this.CuLevel5Name = '';
      this.AsSelf = '';
      return;
    }
    this.AsId = item.asId;
    this.AsCuid = item.asCuid;
    this.AsSassieReferenceNumber = item.asSassieReferenceNumber;
    this.AsLgsid = item.asLgsid;
    this.AsLdvid = item.asLdvid;
    this.AsLdvname = item.asLdvname;
    this.AsSassieShopComments = item.asSassieShopComments;
    this.AsCfid = item.asCfid;
    this.AsGroup = item.asGroup;
    this.AsEvalFee = item.asEvalFee;
    this.AsVat = item.asVat;
    this.AsBillToUnit = item.asBillToUnit;
    this.AsEvid = item.asEvid;
    this.AsExclude = item.asExclude;
    this.AsInid = item.asInid;
    this.AsUsid = item.asUsid;
    this.AsUsname = item.asUsname;
    this.AsMod = item.asMod;
    this.AsCreateId = item.asCreateId;
    this.AsCreateDt = item.asCreateDt;
    this.AsSassieUnitId = item.asSassieUnitId;
    this.AsSassieEvalId = item.asSassieEvalId;
    this.AsSassieAsgnId = item.asSassieAsgnId;
    this.AsSassieSurveyId = item.asSassieSurveyId;
    this.AsEvaluatorCompletedDate = item.asEvaluatorCompletedDate;
    this.AsIob = item.asIob;
    this.AsUninvoiceable = item.asUninvoiceable;
    this.PaidOutsideOfSystem = item.paidOutsideOfSystem;
    this.CanTogglePaidOutsideOfSystem = item.canTogglePaidOutsideOfSystem;
    this.AsPayEvaluator = item.asPayEvaluator;
    this.AsBillClient = item.asBillClient;
    this.AsAdHocGroup = item.asAdHocGroup;
    this.AsDeletedInApollo = item.asDeletedInApollo;
    this.IsApproved = item.isApproved;
    this.AsFieldworkFee = item.asFieldworkFee;
    this.AsIeFee = item.asIeFee;
    this.AsIeFeeAdjustment = item.asIeFeeAdjustment;
    this.AsIeReimbursement = item.asIeReimbursement;
    this.AsIeTravel = item.asIeTravel;
    this.AsIeGaming = item.asIeGaming;
    this.AsIeMisc = item.asIeMisc;
    this.AsIeFeeAdjustmentReason = item.asIeFeeAdjustmentReason;
    this.AsIeReimbursementAdjustmentReason = item.asIeReimbursementAdjustmentReason;
    this.AsIeEvaluatorCompletedDate = item.asIeEvaluatorCompletedDate;
    this.AsIeReceivedDate = item.asIeReceivedDate;
    this.AsIePaymentDate = item.asIePaymentDate;
    this.LgsDesc = item.lgsDesc;
    this.LgsComplete = item.lgsComplete;
    this.CuId = item.cuId;
    this.CuName = item.cuName;
    this.CuCity = item.cuCity;
    this.CuState = item.cuState;
    this.CuCountry = item.cuCountry;
    this.CuUserLocId = item.cuUserLocId;
    this.CcId = item.ccId;
    this.CcCompanyName = item.ccCompanyName;
    this.AsEvname = item.asEvname;
    this.InId = item.inId;
    this.InCiid = item.inCiid;
    this.CiStatusCode = item.ciStatusCode;
    this.CiYrmo = item.CiYrmo;
    this.InRcyid = item.inRcyid;
    this.InRcysymbol = item.inRcysymbol;
    this.InRcycode = item.inRcycode;
    this.InFee = item.inFee;
    this.InFieldworkFee = item.inFieldworkFee;
    this.InFeeAddit = item.inFeeAddit;
    this.InReimbursement = item.inReimbursement;
    this.InMisc = item.inMisc;
    this.InTravel = item.inTravel;
    this.InGaming = item.inGaming;
    this.InCreditAmount = item.inCreditAmount;
    this.InLateFee = item.inLateFee;
    this.InInitialTotalDue = item.inInitialTotalDue;
    this.InVat = item.inVat;
    this.InCurrentTotalDue = item.inCurrentTotalDue;
    this.AsCfname = item.asCfname;
    this.AsCfDisplayName = item.asCfDisplayName;
    this.AsPricingId = item.asPricingId;
    this.AsPricingName = item.asPricingName;
    this.IeId = item.ieId;
    this.IeFee = item.ieFee;
    this.IeFeeAdjustment = item.ieFeeAdjustment;
    this.IeReimbursement = item.ieReimbursement;
    this.IeMisc = item.ieMisc;
    this.IeTravel = item.ieTravel;
    this.IeGaming = item.ieGaming;
    this.Ievat = item.ievat;
    this.IeVatfee = item.ieVatfee;
    this.IeVatreimb = item.ieVatreimb;
    this.IeDue = item.ieDue;
    this.IeTotal = item.ieTotal;
    this.IeTotalFee = item.ieTotalFee;
    this.IeTotalReimb = item.ieTotalReimb;
    this.IeStatusCode = item.ieStatusCode;
    this.IePaymentDate = item.iePaymentDate;
    this.IeRcyid = item.ieRcyid;
    this.IeRcyname = item.ieRcyname;
    this.IeRcysymbol = item.ieRcysymbol;
    this.AsRcyid = item.asRcyid;
    this.AsRcycode = item.asRcycode;
    this.AsRcysymbol = item.asRcysymbol;
    this.AsRcyidOwningOffice = item.asRcyidOwningOffice;
    this.AsRcycodeOwningOffice = item.asRcycodeOwningOffice;
    this.AsRcysymbolOwningOffice = item.asRcysymbolOwningOffice;
    this.AsOwningOfficeId = item.asOwningOfficeId;
    this.AsOwningOfficeName = item.asOwningOfficeName;
    this.AsPricingRoundFee = item.asPricingRoundFee;
    this.AsFee = item.asFee;
    this.AsFeeOwningOffice = item.asFeeOwningOffice;
    this.AsFeeAddit = item.asFeeAddit;
    this.AsFeeReason = item.asFeeReason;
    this.AsReimbursement = item.asReimbursement;
    this.AsMisc = item.asMisc;
    this.AsTravel = item.asTravel;
    this.AsGaming = item.asGaming;
    this.CountryId = item.countryId;
    this.CountryName = item.countryName;
    this.EvaluatorOfficeId = item.evaluatorOfficeId;
    this.EvaluatorOfficeName = item.evaluatorOfficeName;
    this.EvaluatorCurrencyId = item.evaluatorCurrencyId;
    this.EvaluatorCurrencyName = item.evaluatorCurrencyName;
    this.ReimbursementCurrencyId = item.reimbursementCurrencyId;
    this.ReimbursementCurrencyName = item.reimbursementCurrencyName;
    this.ClientReimbursementCurrencyId = item.clientReimbursementCurrencyId;
    this.ClientReimbursementCurrencyName = item.clientReimbursementCurrencyName;
    this.ClientBillingCurrencyName = item.inRcycode;
    this.ClientBillingCurrencyId = item.inRcyid;
    this.AsWaveId = item.asWaveId;
    this.AsWaveName = item.asWaveName;
    this.CuLevel1Name = item.cuLevel1Name;
    this.CuLevel2Name = item.cuLevel2Name;
    this.CuLevel3Name = item.cuLevel3Name;
    this.CuLevel4Name = item.cuLevel4Name;
    this.CuLevel5Name = item.cuLevel5Name;
    this.AsSelf = item.asSelf;
  }

  static NameOfTheIdField() {
    return 'AsId';
  }
  static nameOfTheItemDetailList(item) {
    let warningText = '';
    if (item && item.FromServiceFunctionForListTable === true) {
      if (!item.CcCompanyName) warningText = 'Missing Client - review Apollo client linking';
      if (!warningText && !item.AsCfDisplayName) warningText = 'Missing Project - review Project settings';
      if (!warningText && !item.AsPricingName) warningText = 'Missing Country Pricing - contact Sales';
      if (!warningText && !item.AsEvaluatorCompletedDate) warningText = 'Missing shop date - adjust it in Apollo';
    }

    return (
      <span>
        Assignment
        {warningText && (
          <>
            {' '}
            - <span className='warningText'>{warningText}</span>
          </>
        )}
      </span>
    );
  }

  static MoneyFields = [];

  static numberWithTwoDecimalPlaces = [
    'IeFee',
    'IeFeeAdjustment',
    'IeReimbursement',
    'IeMisc',
    'IeTravel',
    'IeGaming',
    'Ievat',
    'IeTotal',
    'IeDue',
    'InFee',
    'InFeeAddit',
    'InReimbursement',
    'InInitialTotalDue',
    'InMisc',
    'InVat',
    'InTravel',
    'InCreditAmount',
    'InGaming',
    'AsFeeOwningOffice',
    'AsFee',
    'AsFieldworkFee',
    'InFieldworkFee',
    'AsFeeAddit',
    'AsReimbursement',
    'AsMisc',
    'AsTravel',
    'AsGaming',
    'AsIeFee',
    'AsIeFeeAdjustment',
    'AsIeReimbursement',
    'AsIeMisc',
    'AsIeTravel',
    'AsIeGaming',
    'IeDue',
    'InCurrentTotalDue',
  ];

  static Currency() {
    return 'AsRcycode';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return 'ReimbursementCurrencyName';
  }

  static getAttachmentContent(item) {
    return (
      <AttachmentsComponent
        entityTypeId={25}
        entityId={item.AsId}
        isOverWindow={true}
      />
    );
  }

  static DateFields = [
    'AsStartDateRange',
    'AsEndDateRange',
    'AsEvaluatorAssignedDate',
    'AsMod',
    'AsLoginDt',
    'AsPlandt',
    'AsMoreinfo',
    'AsMoreinfoemail',
    'AsReviewassigned',
    'AsScoredt',
    'AsSchedemaildt',
    'AsRemindemaildt',
    'AsReviewNotify',
    'AsDistdt',
    'AsIeReceivedDate',
    'AsIePaymentDate',
    'AsEvaluatorCompletedDate',
    'AsIeEvaluatorCompletedDate',
    'IePaymentDate',
  ];

  static BoolFields = [
    'AsPayEvaluator',
    'AsBillClient',
    'AsUninvoiceable',
    'AsIob',
    'AsEmailsend',
    'AsJobboard',
    'AsSelf',
    'AsTest',
    'AsShopperpay',
    'AsBillToUnit',
    'AsDeletedInApollo',
    'AsPricingRoundFee',
  ];

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Apollo ID',
        orderById: 'AsSassieAsgnId',
        data: 'AsSassieAsgnId',
        type: FieldTypesEnum.DataFieldWithDetails,
        className: 'text-center',
        minWidth: 50,
        roleKey: 'assignment_viewdetail',
      },
      {
        label: 'Project (Name+ID)',
        orderById: 'ProjectName',
        data: (item) => (
          <ShowNameComponent
            serviceFunction={ProjectService.GetProjectNameById}
            id={item.AsCfid}
          />
        ),
        className: 'text-center',
        minWidth: 50,
      },
      {
        label: 'Location',
        orderById: 'AsCuid',
        data: (item) => (
          <ShowNameComponent
            serviceFunction={ClientUnitService.GetClientUnitNameById}
            id={item.AsCuid}
          />
        ),
        minWidth: 50,
      },
      {
        label: 'Country',
        orderById: 'CountryId',
        data: (item) => (
          <ShowNameComponent
            serviceFunction={ClientUnitService.GetClientUnitCountryNameById}
            id={item.AsCuid}
          />
        ),
        className: 'text-center',
        minWidth: 50,
      },
      {
        label: 'Status',
        orderById: 'Status',
        data: (item) => <AssignmentStatusNameComponent id={item.AsLgsid} />,
        className: 'text-center',
        minWidth: 50,
      },
      {
        label: 'Completed On',
        orderById: 'AsEvaluatorCompletedDate',
        data: 'AsEvaluatorCompletedDate',
        className: 'text-center',
        minWidth: 50,
      },
      {
        label: 'Client',
        orderById: 'AsCcid',
        data: (item) => (
          <ShowNameComponent
            serviceFunction={ClientUnitService.GetClientUnitClientNameById}
            id={item.AsCuid}
          />
        ),
        className: 'text-center',
        minWidth: 50,
      },
      {
        label: 'Evaluator',
        orderById: 'AsEvid',
        data: (item) => (
          <ShowNameComponent
            serviceFunction={EvaluatorService.GetEvaluatorNameById}
            id={item.AsSassieEvalId}
          />
        ),
        className: 'text-center',
        minWidth: 50,
      },
      {
        label: ' ',
        orderById: '',
        data: AssignmentItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
        className: 'text-center',
      },
    ];
  }

  // CD-5421: bound by AssignmentAdmin, same pattern as assignmentPaymentsFunction.
  static paidOutsideOfSystemFunction = (item) => {
    alert('Empty function');
  };

  static isPaidOutsideOfSystem(item) {
    return paidOutsideOfSystemHelper.IsPaidOutsideOfSystem(item);
  }

  // Server-computed over every payment type on the assignment (AssignmentTools.CanTogglePaidOutsideOfSystem),
  // the same way the TpJob grid does it. Fails closed: a row that arrives without the field greys the action
  // out rather than offering something the write path would then refuse.
  static canTogglePaidOutsideOfSystem(item) {
    return item.CanTogglePaidOutsideOfSystem === true;
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            text: 'Edit',
            onClick: () => AssignmentItem.editFunction(item.CfId, item),
            iconName: 'fa-solid fa-edit',
            roleKey: 'assignment_edit',
          },
          {
            iconName: 'fa-solid fa-money-check-alt',
            roleKey: 'Evaulator_faicon_EvaluatorPaymentsButton',
            text: 'Assignment Payments',
            onClick: () => AssignmentItem.assignmentPaymentsFunction(item),
          },
          {
            text: 'Assignment Payments (Admin)',
            iconName: 'fa-solid fa-magnifying-glass',
            url: `/assignmentpayments/search?View=All+Payment+Requests&AsSassieAsgnId=${item.AsSassieAsgnId}&SelectedPaymentOffices=`,
            hide: !AuthService.IsAdmin(),
          },
          {
            // CD-5421: the legacy twin of TpJobItem's row action. Disabled once the assignment payment has
            // been exported. The server re-checks in full (every payment type, plus queued exports), so
            // this is an affordance and not the guard.
            iconName: 'fa-solid fa-hand-holding-dollar',
            roleKey: 'assignment_edit',
            text: paidOutsideOfSystemHelper.GetToggleActionText(item),
            disabled: !AssignmentItem.canTogglePaidOutsideOfSystem(item),
            onClick: () => AssignmentItem.paidOutsideOfSystemFunction(item),
          },
        ]}
      />
    );
  }

  static editFunction = (id, item, itemList) => {
    alert('Empty function');
  };

  static assignmentPaymentsFunction = (item) => {
    alert('Empty function');
  };

  static serviceFunctionForListTable = (item) => AssignmentService.GetAssignmentById(item.AsId);
  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-home',
      data: [
        { name: 'AsSassieAsgnId', label: 'Apollo ID' },
        { name: (item) => <AssignmentStatusNameComponent id={item.AsLgsid} />, label: 'Status' },
        { name: 'AsEvaluatorCompletedDate', label: 'Completed Date' },
        { name: 'CcCompanyName', label: 'Client' },
        { name: 'CuName', label: 'Location' },
        { name: 'AsEvname', label: 'Evaluator' },
        { name: 'AsCfDisplayName', label: 'Project' },
        {
          name: (item) => (
            <ShowNameComponent
              serviceFunction={ClientUnitService.GetClientUnitCountryNameById}
              id={item.AsCuid}
            />
          ),
          label: 'Country',
        },
        { name: 'AsSassieUnitId', label: 'Apollo Database ID' }, //
        { name: 'AsSassieEvalId', label: 'Evaluator ID' },
        { name: (item) => <SurveyNameComponent surveyId={item.AsSassieSurveyId} />, label: 'Survey' },
        { name: 'CuUserLocId', label: 'Apollo Location ID' },
        { name: 'AsDeletedInApollo', label: 'Deleted in Apollo?' },
        { name: 'AsWaveName', label: 'Wave' },
        { name: 'AsAdHocGroup', label: 'Ad-Hoc Invoice Group' },
        { name: 'AsBillClient', label: 'Bill Client?' },
        { name: 'AsPricingName', label: 'Pricing' },
        { name: 'AsSelf', label: 'Self-Assigned?' },
        { name: 'AsPayEvaluator', label: 'Pay Evaluator?' },
        { name: '', label: '' },
        { name: '', label: '' },
        { name: 'AsUninvoiceable', label: 'Uninvoicable?' },
        { name: (item) => JsxHelper.YesNo(item.PaidOutsideOfSystem), label: 'Paid Outside of System' },
        { name: '-', label: '' },
        { name: '-message-', label: 'Fieldwork Office', className: 'text-left' },
        { name: 'AsLdvname', label: 'Fieldwork Office' },
        { name: 'InFieldworkFee', label: 'Fieldwork Fee' },
        { name: '-', label: '' },

        { name: '-message-', label: 'Client Billing', className: 'text-left' },
        { name: AssignmentItem.getBareInvoiceUrl, label: 'BARE Invoice #' },
        { name: 'InReimbursement', label: 'Reimbursement' },
        { name: 'InInitialTotalDue', label: 'Initial Total' },
        {
          name: (item) => (
            <LookupText
              lookupId={43}
              value={item.CiStatusCode}
            />
          ),
          label: 'Status',
        },
        { name: 'InMisc', label: 'Misc' },
        { name: 'InVat', label: 'Tax' },
        { name: 'ClientBillingCurrencyName', label: 'Currency' },
        { name: 'InTravel', label: 'Travel' },
        { name: 'InCreditAmount', label: 'Credit' },
        { name: 'InFee', label: 'Client Fee' },
        { name: 'InGaming', label: 'Gaming' },
        { name: 'InCurrentTotalDue', label: 'Current Total Due' },
        { name: 'InFeeAddit', label: 'Additional Fee' },
        { name: '-', label: '' },

        { name: '-message-', label: 'Evaluator Payment', className: 'text-left' },
        { name: 'IePaymentDate', label: 'Payment Export Date' },
        { name: 'IeReimbursement', label: 'Reimbursement' },
        { name: 'IeTotal', label: 'Initial Total' },
        {
          name: (item) => (
            <LookupText
              lookupId={45}
              value={item.IeStatusCode}
            />
          ),
          label: 'Status',
        },
        { name: 'IeMisc', label: 'Misc' },
        { name: 'Ievat', label: 'Tax' },
        { name: 'IeRcyname', label: 'Currency' },
        { name: 'IeTravel', label: 'Travel' },
        { name: 'IeDue', label: 'Current Total Due' },
        { name: 'IeFee', label: 'Evaluator Fee' },
        { name: 'IeGaming', label: 'Gaming' },
        { name: '', label: '' },
        { name: 'IeFeeAdjustment', label: 'Additional Fee' },
      ],
    },
    {
      tabName: 'Apollo',
      tabLabel: 'Apollo',
      icon: 'fa-solid fa-info',
      data: [
        { name: '-', label: '' },
        { name: '-message-', label: 'Owning Office', className: 'text-left' },
        { name: 'EvaluatorOfficeName', label: 'Evaluator Payment Office' },
        { name: 'AsOwningOfficeName', label: 'Owning Office' },
        { name: 'AsRcycodeOwningOffice', label: 'Owning Office Fee Currency' },
        { name: 'AsFeeOwningOffice', label: 'Owning Office Fee' },
        { name: 'AsPricingRoundFee', label: 'Owning Office Fee Round' },
        { name: '-', label: '' },

        { name: '-message-', label: 'Client', className: 'text-left' },
        { name: 'AsRcycode', label: 'Fee Currency' },
        { name: 'ClientReimbursementCurrencyName', label: 'Reimbursement Currency' },
        { name: 'AsMisc', label: 'Misc' },
        { name: 'AsFee', label: 'Fee' },
        { name: 'AsReimbursement', label: 'Reimbursement' },
        { name: 'AsTravel', label: 'Travel' },
        { name: 'AsFieldworkFee', label: 'Fieldwork Fee' },
        { name: '', label: '' },
        { name: 'AsGaming', label: 'Gaming' },
        { name: 'AsFeeAddit', label: 'Additional Fee' },
        { name: '', label: '' },
        { name: '-', label: '' },
        { name: '-message-', label: 'Evaluator', className: 'text-left' },
        { name: 'EvaluatorCurrencyName', label: 'Fee Currency' },
        { name: 'ReimbursementCurrencyName', label: 'Reimbursement Currency' },
        { name: 'AsIeMisc', label: 'Misc' },
        { name: 'AsIeFee', label: 'Fee' },
        { name: 'AsIeReimbursement', label: 'Reimbursement' },
        { name: 'AsIeTravel', label: 'Travel' },
        { name: 'AsIeFeeAdjustment', label: 'Additional Fee' },
        { name: '', label: '' },
        { name: 'AsIeGaming', label: 'Gaming' },
      ],
    },
    {
      tabName: 'Comments',
      tabLabel: 'Comments',
      icon: 'fa-solid fa-comments',
      data: [
        { name: AssignmentItem.getCommentsContent, label: 'Comments', width: TabListTableCellWidthEnum.TwoLines },
        { name: '-message-', label: 'The comments above are related to the primary user.' },
      ],
    },
    {
      tabName: 'Attachments',
      tabLabel: 'Attachments',
      icon: 'fa-solid fa-paperclip',
      data: [
        { name: AssignmentItem.getAttachmentContent, label: 'Attachments', width: TabListTableCellWidthEnum.TwoLines },
      ],
    },
    {
      tabName: 'Log',
      tabLabel: 'Log',
      icon: 'fa-solid fa-stream',
      data: [{ name: AssignmentItem.getLogContent, label: 'Log', width: TabListTableCellWidthEnum.TwoLines }],
    },
  ];

  static getBareInvoiceUrl(item) {
    return urlHelper.getIconLinkComponentFigma(
      item.InCiid,
      '',
      '',
      'clientinvoicedetails',
      `id=${item.InCiid}`,
      'Open up in a new tab'
    );
  }

  static getLogContent(item) {
    return (
      <LogComponent
        entityType='Assignment'
        entityId={item.AsId}
      />
    );
  }

  static getCommentsContent(item) {
    return (
      <Comments
        entityTypeId={25}
        entityId={item.AsId}
      />
    );
  }
}
